'use client';

import React__default from 'react';

var SearchIcon = function (_a) {
    var className = _a.className;
    return (React__default.createElement("svg", { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: className },
        React__default.createElement("path", { d: 'M10.08 1.44A8.154 8.154 0 0 0 1.92 9.6a8.154 8.154 0 0 0 8.16 8.16c1.61 0 3.101-.473 4.365-1.275l5.895 5.895 2.04-2.04-5.82-5.805A8.102 8.102 0 0 0 18.24 9.6a8.154 8.154 0 0 0-8.16-8.16Zm0 1.92a6.228 6.228 0 0 1 6.24 6.24 6.228 6.228 0 0 1-6.24 6.24A6.228 6.228 0 0 1 3.84 9.6a6.228 6.228 0 0 1 6.24-6.24Z', fill: '#888' })));
};

export { SearchIcon as default };
//# sourceMappingURL=SearchIcon.js.map
